export const getLanguageFromStorage = () => {
  return window.localStorage.getItem('language') || 'sv';
};
